import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcSkipped = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 2c7.732 0 14 6.268 14 14s-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2ZM4 16c0 6.627 5.373 12 12 12 2.713 0 5.216-.9 7.227-2.42L6.823 8.268A11.952 11.952 0 0 0 4 16ZM16 4a11.952 11.952 0 0 0-7.765 2.85l16.482 17.397A11.959 11.959 0 0 0 28 16c0-6.627-5.373-12-12-12Z"
      fill="#B0322B"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgIcSkipped;
